module.exports = __webpack_public_path__ + "static/media/Vu_Minh_Hai.29a78e8a.jpg";